import { getPrimaryMatterStatuteFromList } from "@/lib/data/static/matters/statuteStatics";
import type { MatterStatuteOfLimitations } from "@/lib/types";

type ReportStatuteValue =
  | string
  | null
  | undefined
  | Array<Partial<MatterStatuteOfLimitations> & Record<string, unknown>>;

export const resolveReportPrimaryStatute = (
  statutes: ReportStatuteValue,
  legacyConfirmed?: boolean | null,
) => {
  if (Array.isArray(statutes)) {
    const primaryStatute = getPrimaryMatterStatuteFromList(statutes);
    const rawConfirmed = primaryStatute?.confirmed;

    return {
      matterStatuteOfLimitations: primaryStatute?.date ?? null,
      matterStatuteOfLimitationsConfirmed:
        typeof rawConfirmed === "boolean" ? rawConfirmed : null,
    };
  }

  return {
    matterStatuteOfLimitations: statutes ?? null,
    matterStatuteOfLimitationsConfirmed: legacyConfirmed ?? null,
  };
};
